// removed by extract-text-webpack-plugin
module.exports = {"opportunities_list":"src-styles----careers-module---opportunities_list---1VT5Y"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/careers.module.scss
// module id = 807
// module chunks = 185408970092611